export default "__VITE_ASSET__31d2dfb4__"